import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faPencil } from '@fortawesome/pro-light-svg-icons'
import { faCog } from '@fortawesome/pro-solid-svg-icons'

import { IconWithMenu, Link } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'
import { generateUrls as generateInvoiceUrls } from '@hooks/useInvoice'
import { generateUrls as generateCreditNoteUrls } from '@hooks/useCreditNote'

import { CreditNoteModel, InvoiceModel } from '@models/types'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import { getInvoiceDownloadUrl } from '@functions/invoice'

interface CogOptionsProps {
  item: InvoiceModel | CreditNoteModel,
}

const CogOptions = (params: CogOptionsProps) => {
  const { item } = params

  const { campaign_id, id, type } = item

  const invoiceAttachments = useSelector(reduxState => reduxState.entities.invoiceAttachments)
  const downloadUrl = type === 'Invoice' ? getInvoiceDownloadUrl({ invoice: item, invoiceAttachments }) : undefined

  const generateUrls = type === 'Invoice' ? generateInvoiceUrls : generateCreditNoteUrls
  // @ts-expect-error TS2339
  const { editCreditNoteUrl, editCampaignInvoiceUrl } = generateUrls(
    { id, campaign_id },
    { prefixRoute: `campaigns/${campaign_id}` },
  )

  return (
    <IconWithMenu
      boxProps={{ alignItems: 'center', marginRight: 'small' }}
      icon={(
        <Link greyLink>
          <FontAwesomeIcon icon={faCog} />
        </Link>
    )}
      shouldUsePortal
    >
      {/*
       // @ts-expect-error TS2741 */}
      <IconWithMenu.Menu closeOnClick>
        <Link key={`${type}-${id}-manage`} href={editCampaignInvoiceUrl || editCreditNoteUrl}>
          <FontAwesomeIcon icon={faPencil} />{type === 'Invoice' ? 'Manage Invoice' : 'Manage Credit Note' }
        </Link>

        {type === 'Invoice' && (
          <AuthenticatedDownload key="download-pdf">
            <Link href={downloadUrl} key={`${id}-download`} target="blank">
              <FontAwesomeIcon icon={faDownload} /> Download
            </Link>
          </AuthenticatedDownload>
        )}
      </IconWithMenu.Menu>
    </IconWithMenu>
  )
}
export default CogOptions
